import { isEmpty } from "lodash";
import { Suspense } from "react";
import shallow from "zustand/shallow";

import Friend from "@/components/Friend";
import ShareApp from "@/components/ShareApp";
import { useAppStore } from "@/store/app";
import {
  useReplicacheFriendIdMap,
  useReplicacheFriends,
} from "@/store/replicache";
import LoadingIndicator from "./LoadingIndicator";

const LOG_TAG = "👫 FriendList";

const FriendList = () => {
  //const { friendAdd, friendRemove } = useReplicacheStore();
  const { user } = useAppStore(({ user }) => ({ user }), shallow);
  const { friends } = useReplicacheFriends();
  const { friendIdMap } = useReplicacheFriendIdMap();
  const friendsArray = isEmpty(friendIdMap)
    ? []
    : Object.values(friends)
        .sort((a, b) =>
          friendIdMap[a.id]?.deleted_timestamp === -1 // move potentially new friend requests to the top
            ? -1
            : friendIdMap[b.id].added_timestamp -
              friendIdMap[a.id].added_timestamp,
        )
        .filter((friend) => friendIdMap[friend.id].deleted_timestamp <= 0); // filter out deleted friends

  // const handleFriendAdd = (friend: User) => {
  //   friendAdd({ friend, ts: Date.now() });
  // };

  // const handleFriendRemove = (friend: User) => {
  //   const confirm = window.confirm(
  //     "Removing a friend removes their songs and sets from your Songbook. Are you sure you want to remove this friend?",
  //   );
  //   if (!confirm) return;
  //   friendRemove({ friendId: friend.id, ts: Date.now() });
  // };

  //console.debug(LOG_TAG, "render", { user, friends });
  if (!user) {
    return (
      <div className="my-2 py-2 px-4 text-accent-content">No friends yet</div>
    );
  }
  return (
    <>
      <div className="bg-primary text-primary-content p-4 flex justify-between items-center">
        <div>Share your Songbook with friends!</div>
        <div>
          <ShareApp />
        </div>
      </div>
      <div className="p-4">
        <Suspense fallback={<LoadingIndicator />}>
          {friendsArray.map((friend) => (
            <Friend
              key={`friend-${friend.id}`}
              friendId={friend.id}
              friend={friend}
            />
          ))}
        </Suspense>
      </div>
    </>
  );
};

export default FriendList;
